import { Model } from '../model.interface';
import { FeaturedReviewModel } from './featured-review.model';

/**
 * Class used to represent a Review Object
 */
export class FeaturedReviewStatsModel implements Model {
  public totalCount: number;
  public averageRating: number;
  public countRatingStars: Array<number>;

  /**
   * Constructor to initialize the properties
   * - Make sure the properties are initialized (to avoid unexpected undefined values)
   * @constructor
   */
  constructor() {
    this.totalCount = 0;
    this.averageRating = 0;
    this.countRatingStars = new Array(0);
  }
}

/**
 * Helper function to sanitize an array of data that comes from the Backend.
 * @param products The parsed reviews Array
 * @returns <FeaturedReviewStatsModel> An FeaturedReviewStats instances.
 */
export const getStatsFromReviewsArray = (
  products?: Array<FeaturedReviewModel> | null
): FeaturedReviewStatsModel => {
  const ROUND = 10;
  const STARS = 5;

  const stats: FeaturedReviewStatsModel = new FeaturedReviewStatsModel();

  // Ensure data is not null, and that is an array
  if (products && products.length > 0) {
    stats.totalCount = products.length;

    stats.averageRating =
      products.reduce(function (accum, review) {
        return accum + review.rating;
      }, 0) / stats.totalCount;
    stats.averageRating = Math.round(stats.averageRating * ROUND) / ROUND;

    for (let s = 0; s <= STARS; s++) {
      stats.countRatingStars[s] = products.filter((review) => {
        if (review.rating >= s && review.rating < s + 1) {
          return true;
        }
        return false;
      }).length;
    }
  }
  return stats;
};
